import { usePathname } from 'next/navigation';

interface NewCarSourceFieldConfig {
  useAlternativeNewCarSource: boolean;
  getNewCarSourceValue: (item: {
    source?: string;
    source_bo?: string;
  }) => string;
}

const NEW_CAR_SOURCE_FIELD_CONFIG = {
  '/buy-online': {
    useAlternativeNewCarSource: true,
    sourceField: 'source_bo',
  },
} as const;

export const useNewCarSourceFieldConfig = (): NewCarSourceFieldConfig => {
  const pathname = usePathname();

  const config = Object.entries(NEW_CAR_SOURCE_FIELD_CONFIG).find(
    ([path]) => pathname === path || pathname.startsWith(path),
  )?.[1];

  const useAlternativeNewCarSource =
    config?.useAlternativeNewCarSource ?? false;

  const getNewCarSourceValue = (item: {
    source?: string;
    source_bo?: string;
  }): string => {
    if (useAlternativeNewCarSource && config?.sourceField === 'source_bo') {
      return item.source_bo || item.source || '';
    }
    return item.source || '';
  };

  return {
    useAlternativeNewCarSource,
    getNewCarSourceValue,
  };
};
